import { create } from 'zustand'

/** The entity currently selected in the constellation — surfaced in the right control plane. */
export interface Selected {
  id: string
  name: string
  type: string
  world: string | null
  score: number | null
  domain?: string | null
  attributes?: Record<string, unknown> | null
}

interface SelectionState {
  selected: Selected | null
  select: (s: Selected | null) => void
}

export const useSelection = create<SelectionState>((set) => ({
  selected: null,
  select: (s) => set({ selected: s }),
}))
